import { html, nothing, unsafeCSS } from "lit";
import { customElement, property } from "lit/decorators.js";
import SlotController from "@/common/controllers/slot";
import "@/components/badge";
import { EkoElement } from "@/utilities/element";
import "@/components/menu-item";
import style from "./option.css?inline";

@customElement("eko-option")
class Option extends EkoElement {
  static styles = [...EkoElement.styles, unsafeCSS(style)];

  private beforeSlot = new SlotController(this, "before");

  @property({ reflect: true })
  href?: string;

  @property({ reflect: true, type: Boolean })
  selected: boolean = false;

  @property({ reflect: true })
  value: string = "";

  @property({ reflect: true })
  variant: "option" | "badge" = "option";

  render() {
    return html`
      <div class="eko-option" before=${this.beforeSlot.tagName}>
        ${this.variant === "option" || this.href ? this.renderOption() : this.renderBadge()}
      </div>
    `;
  }

  renderBadge() {
    return html`
      <eko-badge variant="square" tabindex="-1">
        <slot name="before" slot="before"></slot>
        <slot></slot>
        <eko-icon name="x-close" slot="after"></eko-icon>
      </eko-badge>
    `;
  }

  renderOption() {
    return html`
      <eko-menu-item ?active=${this.selected} href=${this.href} type="button" tabindex="-1">
        <slot name="before" slot="before"></slot>
        <slot></slot>
        <slot name="append" slot="append"></slot>
        ${this.selected
          ? html`<eko-icon
              name="check"
              slot="after"
              style="--eko-icon-color: var(--_eko-option-selected-icon-color); --eko-icon-size: var(--_eko-option-selected-icon-size);"></eko-icon>`
          : nothing}
      </eko-menu-item>
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    "eko-option": Option;
  }
}

export default Option;
